import * as types from '../API/ActionTypes';
import InitialState from './initialState';
import _ from 'lodash';
import { isS3URLExpired, isURL } from '../Utils/AppUtils';

export function addSuperAssetCommentErrorReducer(state = InitialState.addSuperAssetCommentErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ADD_SUPER_ASSET_COMMENT_ERROR:
			return action.addSuperAssetCommentErrorFlag;
		default:
			return state;
	}
}

export function addSuperAssetCommentLoadingReducer(state = InitialState.addSuperAssetCommentLoading, action) 
{
	switch (action.type) 
	{
		case types.ADD_SUPER_ASSET_COMMENT_LOADING:
			return action.addSuperAssetCommentLoading;
		default:
			return state;
	}
}

export function addAssetCommentErrorReducer(state = InitialState.addAssetCommentErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ADD_ASSET_COMMENT_ERROR:
			return action.addAssetCommentErrorFlag;
		default:
			return state;
	}
}

export function addAssetCommentLoadingReducer(state = InitialState.addAssetCommentLoading, action) 
{
	switch (action.type) 
	{
		case types.ADD_ASSET_COMMENT_LOADING:
			return action.addAssetCommentLoading;
		default:
			return state;
	}
}

export function assetCommentsErrorReducer(state = InitialState.assetCommentsErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ASSET_COMMENTS_ERROR:
			return action.assetCommentsErrorFlag;
		default:
			return state;
	}
}

export function assetCommentsLoadingReducer(state = InitialState.assetCommentsLoading, action) 
{
	switch (action.type) 
	{
		case types.ASSET_COMMENTS_LOADING:
			return action.assetCommentsLoading;
		default:
			return state;
	}
}

export function assetCommentsReducer(state = InitialState.assetComments, action) 
{
	switch (action.type) 
	{
		case types.ASSET_COMMENTS:
			try
			{
				return {
					assetComments: action.assetComments
				}
			} catch(error)
			{
				console.log("Load asset comments", error);
			}
			break;
		case types.ADD_ASSET_COMMENT:
			try
			{
				return {
					...state,
					assetComments:
					[
						action.assetComment,
						...state.assetComments
					]
				}
			} catch(error)
			{
				console.log("Add asset comment", error);
			}
			break;
		default:
			return state;
	}
}

export function assetCountErrorReducer(state = InitialState.assetCountErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ASSET_COUNT_ERROR:
			return action.assetCountErrorFlag;
		default:
			return state;
	}
}

export function assetCountLoadingReducer(state = InitialState.assetCountDataLoading, action) 
{
	switch (action.type) 
	{
		case types.ASSET_COUNT_LOADING:
			return action.assetCountDataLoading;
		default:
			return state;
	}
}

export function assetCountReducer(state = InitialState.assetCount, action) 
{
	switch (action.type) 
	{
		case types.ASSET_COUNT:
			return action.assetCount;
		default:
			return state;
	}
}

export function assetConditionInfoErrorReducer(state = InitialState.assetConditionInfoErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ASSET_CONDITION_INFO_ERROR:
				return action.assetConditionInfoErrorFlag;
		default:
				return state;
	}
}

export function assetConditionInfoLoadingReducer(state = InitialState.assetConditionInfoLoading, action) 
{
	switch (action.type) 
	{
		case types.ASSET_CONDITION_INFO_LOADING:
			return action.assetConditionInfoLoading;
		default:
			return state;
	}
}

export function assetConditionInfoReducer(state = InitialState.assetConditionInfo, action) 
{
	switch (action.type) 
	{
		case types.ASSET_CONDITION_INFO:
			return action.assetConditionInfo;
		default:
			return state;
	}
}

export function assetDetailsErrorReducer(state = InitialState.assetDetailsErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ASSET_DETAILS_ERROR:
			return action.assetDetailsErrorFlag;
		default:
			return state;
	}
}

export function assetDetailsLoadingReducer(state = InitialState.assetDetailsLoading, action) 
{
	switch (action.type) 
	{
		case types.ASSET_DETAILS_LOADING:
			return action.assetDetailsLoading;
		default:
			return state;
	}
}

export function assetDetailsReducer(state = InitialState.assetDetails, action) 
{
	switch (action.type) 
	{
		case types.ASSET_DETAILS:
			return action.assetDetails;
		case types.UPDATE_MOTE_STATE:
			return {
				...state,
				moteState : action.moteState
			}
		case types.UPDATE_CUST_ASSET_TAG:
			return {
				...state,
				assetTag: action.updatedCustAssetTag
			}
		case types.REPLACE_SENSOR:
			return {
				...state,
				moteSerialNumber : action.replaceSensorOutputData?.moteSerialNumber,
				moteInfo: action.replaceSensorOutputData?.moteInfo,
				sensorMacAddress: action.replaceSensorOutputData?.sensorMacAddress,
				batteryLevel: action.replaceSensorOutputData?.batteryLevel
			}
		case types.ADD_SENSOR:
			return {
				...state,
				moteSerialNumber : action.addSensorOutputData?.moteSerialNumber,
				moteInfo: action.addSensorOutputData?.moteInfo,
				sensorMacAddress: action.addSensorOutputData?.sensorMacAddress,
				moteLocationLabel: action.addSensorOutputData?.locationLabel,
				moteState: action.addSensorOutputData?.moteState,
				moteId: action.addSensorOutputData?.moteId
			};
		case types.ADD_LATEST_COMMENT_IN_ASSET_DETAILS:
			return {
				...state,
				comment : action.comment?.comment
			}
		case types.UPDATE_SENSOR_INFO:
			return {
				...state,
				moteInfo: action.updateSensorInfo
			}
		case types.DETACH_SENSOR:
			return {
				...state,
				...action.detachSensor
			}

		default:
			return state;
	}
}

export function assetDownloadMeasurementDataErrorReducer(state = InitialState.assetDownloadMeasurementDataErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ASSET_DOWNLOAD_MEASUREMENT_DATA_ERROR:
			return action.assetDownloadMeasurementDataErrorFlag;
		default:
			return state;
	}
}

export function assetDownloadMeasurementDataLoadingReducer(state = InitialState.assetDownloadMeasurementDataLoading, action) 
{
	switch (action.type) 
	{
		case types.ASSET_DOWNLOAD_MEASUREMENT_DATA_LOADING:
			return action.assetDownloadMeasurementDataLoading;
		default:
			return state;
	}
}

export function assetGraphCurrentDataReducer(state = InitialState.assetGraphCurrentData, action) 
{
	switch (action.type) 
	{
		case types.ASSET_GRAPH_CURRENT_DATA:
			return action.assetGraphCurrentData;
		default:
			return state;
	}
}

export function assetGraphHistoricalDataReducer(state = InitialState.assetGraphHistoricalData, action) 
{
	switch (action.type) 
	{
		case types.ASSET_GRAPH_HISTORICAL_DATA:
			return action.assetGraphHistoricalData;
		default:
			return state;
	}
}

export function assetGraphErrorReducer(state = InitialState.assetGraphErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ASSET_GRAPH_ERROR:
			return action.assetGraphErrorFlag;
		default:
			return state;
	}
}

export function assetGraphLoadingReducer(state = InitialState.assetGraphDataLoading, action) 
{
	switch (action.type) 
	{
		case types.ASSET_GRAPH_LOADING:
			return action.assetGraphDataLoading;
		default:
			return state;
	}
}

export function assetListErrorReducer(state = InitialState.assetOutputErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ASSET_LIST_ERROR:
			return action.assetOutputErrorFlag;
		default:
			return state;
	}
}

export function assetListLoadingReducer(state = InitialState.assetOutputDataLoading, action) 
{
	switch (action.type) 
	{
		case types.ASSET_LIST_LOADING:
			return action.assetOutputDataLoading;
		default:
			return state;
	}
}

export function assetListReducer(state = InitialState.assetOutputData, action) 
{
	switch (action.type) 
	{
		case types.ASSET_LIST:
			return action.assetOutputData;

		case types.UPDATE_SUPER_ASSET_ALTERNATE_ID:
			if(!state.assetList)
			{
				return state;
			}
			return {
				...state,
				assetList: state.assetList.map(superAsset =>
				{
					if(superAsset.superAssetId !== action.payload.superAssetId)
					{
						return superAsset;
					}
					// Keeping the alternate id in sync on the equipment and on each of its assets, So that the search by alternate id works without a refetch
					return {
						...superAsset,
						alternateId: action.payload.alternateId,
						assets: (superAsset.assets ?? []).map(asset => ({ ...asset, superAssetAlternateId: action.payload.alternateId }))
					};
				})
			};

		default:
			return state;
	}
}

export function centerDateTimeListErrorReducer(state = InitialState.centerDateTimeOutputErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.CENTER_DATE_TIME_LIST_ERROR:
			return action.centerDateTimeOutputErrorFlag;
		default:
			return state;
	}
}

export function centerDateTimeListLoadingReducer(state = InitialState.centerDateTimeOutputDataLoading, action) 
{
	switch (action.type) 
	{
		case types.CENTER_DATE_TIME_LIST_LOADING:
			return action.centerDateTimeOutputDataLoading;
		default:
			return state;
	}
}

export function centerDateTimeListReducer(state = InitialState.centerDateTimeList, action) 
{
	switch (action.type) 
	{
		case types.CENTER_DATE_TIME_LIST:
			return action.centerDateTimeList;
		default:
			return state;
	}
}

export function fetchFaultEnumErrorReducer(state = InitialState.faultEnumListErrorFlag, action) 
{
    switch (action.type) 
    {
          case types.FAULT_ENUM_LIST_ERROR:
                return action.faultEnumListErrorFlag;
          default:
                return state;
    }
}

export function fetchFaultEnumLoadingReducer(state = InitialState.faultEnumListLoading, action) 
{
    switch (action.type)
    {
          case types.FAULT_ENUM_LIST_LOADING:
                return action.faultEnumListLoading;
          default:
                return state;
    }
}

export function fetchFaultEnumReducer(state = InitialState.faultEnumList, action) 
{
    switch (action.type) 
    {
          case types.FAULT_ENUMS_LIST:
                return action.faultEnumList;
          default:
                return state;
    }
}

export function metricListErrorReducer(state = InitialState.metricListErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.METRICS_LIST_ERROR:
			return action.metricListErrorFlag;
		default:
			return state;
	}
}

export function metricListLoadingReducer(state = InitialState.metricListLoading, action) 
{
	switch (action.type) 
	{
		case types.METRICS_LIST_LOADING:
			return action.metricListLoading;
		default:
			return state;
	}
}

export function metricListReducer(state = InitialState.metricList, action) 
{
	switch (action.type) 
	{
		case types.METRICS_LIST:
			return action.metricList;
		default:
			return state;
	}
}

export function plotlyGraphAndTableJsonErrorReducer(state = InitialState.plotlyGraphAndTableJsonOutputErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.PLOTLY_GRAPH_AND_TABLE_JSON_ERROR:
			return action.plotlyGraphAndTableJsonOutputErrorFlag;
		default:
			return state;
	}
}

export function plotlyGraphAndTableJsonLoadingReducer(state = InitialState.plotlyGraphAndTableJsonOutputLoading, action) 
{
	switch (action.type) 
	{
		case types.PLOTLY_GRAPH_AND_TABLE_JSON_LOADING:
			return action.plotlyGraphAndTableJsonOutputLoading;
		default:
			return state;
	}
}

export function plotlyGraphAndTableJsonReducer(state = InitialState.plotlyGraphAndTableJson, action) 
{ 
		switch (action.type)
		{
			case types.PLOTLY_GRAPH_AND_TABLE_JSON:
				try
				{
					return {
						plotlyGraphAndTableJson: action.plotlyGraphAndTableJson
					}
				} catch(error)
				{
						console.log(error)
				}
				break;
			case types.ADD_PLOTLY_GRAPH_AND_TABLE_JSON:
				try
				{
					return {
						...state,
						plotlyGraphAndTableJson:
						[
								...state.plotlyGraphAndTableJson,
								action.plotlyGraphAndTableObj
						]
					}
				} catch(error)
				{
						console.log(error)
				}
				break;
			default:
				return state;
	}
}

export function quickFeedbackDataReducer(state = InitialState.quickFeedbackData, action) 
{
    switch (action.type) 
    {
          case types.QUICK_FEEDBACK_RESPONSE:
                return action.quickFeedbackData;
          default:
                return state;
    }
}

export function quickFeedbackErrorReducer(state = InitialState.quickFeedbackErrorFlag, action) 
{
    switch (action.type) 
    {
          case types.QUICK_FEEDBACK_ERROR:
                return action.quickFeedbackErrorFlag;
          default:
                return state;
    }
}

export function quickFeedbackLoadingReducer(state = InitialState.quickFeedbackLoading, action) 
{
    switch (action.type) 
    {
          case types.QUICK_FEEDBACK_LOADING:
                return action.quickFeedbackLoading;
          default:
                return state;
    }
}

export function replaceSensorErrorReducer(state = InitialState.replaceSensorErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.REPLACE_SENSOR_ERROR:
			return action.replaceSensorErrorFlag;
		default:
			return state;
	}
}

export function addSensorErrorReducer(state = InitialState.addSensorErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ADD_SENSOR_ERROR:
			return action.addSensorErrorFlag;
		default:
			return state;
	}
}


export function replaceSensorLoadingReducer(state = InitialState.replaceSensorLoading, action) 
{
	switch (action.type) 
	{
		case types.REPLACE_SENSOR_LOADING:
			return action.replaceSensorLoading;
		default:
			return state;
	}
}

export function addSensorLoadingReducer(state = InitialState.addSensorLoading, action)
{
	switch (action.type)
	{
		case types.ADD_SENSOR_LOADING:
			return action.addSensorLoading;
		default:
			return state;
	}
}

export function superAssetCommentsErrorReducer(state = InitialState.superAssetCommentsErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.SUPER_ASSET_COMMENTS_ERROR:
			return action.superAssetCommentsErrorFlag;
		default:
			return state;
	}
}

export function superAssetCommentsLoadingReducer(state = InitialState.superAssetCommentsLoading, action) 
{
	switch (action.type) 
	{
		case types.SUPER_ASSET_COMMENTS_LOADING:
			return action.superAssetCommentsLoading;
		default:
			return state;
	}
}

export function superAssetCommentsReducer(state = InitialState.superAssetComments, action) 
{
	switch (action.type) 
	{
		case types.SUPER_ASSET_COMMENTS:
			try
			{
				return {
					superAssetComments: action.superAssetComments
				}
			} catch(error)
			{
				console.log("Error while fetching super asset comments", error);
			}
			break;
		case types.ADD_SUPER_ASSET_COMMENT:
			try
			{
				return {
					...state,
					superAssetComments:
					[
						action.superAssetComment,
						...state.superAssetComments
					]
				}
			} catch(error)
			{
				console.log("Error while adding super asset comment", error);
			}
			break;
		default:
			return state;
	}
}

export function superAssetDetailsReducer(state = InitialState.superAssetDetails, action)
{
	switch (action.type)
	{
		case types.SUPER_ASSET_DETAILS:
			return action.superAssetDetails || {};
		default:
			return state;
	}
}

export function superAssetDetailsErrorReducer(state = InitialState.superAssetDetailsErrorFlag, action)
{
	switch (action.type)
	{
		case types.SUPER_ASSET_DETAILS_ERROR:
			return action.superAssetDetailsErrorFlag;
		default:
			return state;
	}
}

export function superAssetDetailsLoadingReducer(state = InitialState.superAssetDetailsLoading, action)
{
	switch (action.type)
	{
		case types.SUPER_ASSET_DETAILS_LOADING:
			return action.superAssetDetailsLoading;
		default:
			return state;
	}
}

export function updateMoteStatusErrorReducer(state = InitialState.updateMoteStateErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.UPDATE_MOTE_STATE_ERROR:
			return action.updateMoteStateErrorFlag;
		default:
			return state;
	}
}

export function updateMoteStatusLoadingReducer(state = InitialState.updateMoteStateLoading, action) 
{
	switch (action.type)
	{
		case types.UPDATE_MOTE_STATE_LOADING:
			return action.updateMoteStateLoading;
		default:
			return state;
	}
}

export function updateCustAssetTagErrorReducer(state = InitialState.updateCustAssetTagErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.UPDATE_CUST_ASSET_TAG_ERROR:
			return action.updateCustAssetTagErrorFlag;
		default:
			return state;
	}
}

export function updateCustAssetTagLoadingReducer(state = InitialState.updateCustAssetTagLoading, action) 
{
	switch (action.type) 
	{
		case types.UPDATE_CUST_ASSET_TAG_LOADING:
			return action.updateCustAssetTagLoading;
		default:
			return state;
	}
}

export function superAssetImagesErrorReducer(state = InitialState.superAssetImagesErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.FETCH_SUPER_ASSET_IMAGES_ERROR:
			return action.superAssetImagesErrorFlag;
		default:
			return state;
	}
}

export function superAssetImagesLoadingReducer(state = InitialState.superAssetImagesLoading, action) 
{
	switch (action.type)
	{
		case types.FETCH_SUPER_ASSET_IMAGES_LOADING:
			return action.superAssetImagesLoading;
		default:
			return state;
	}
}

export function superAssetImagesReducer(state = InitialState.superAssetImages, action) 
{
	switch (action.type)
	{
		case types.FETCH_SUPER_ASSET_IMAGES:
			let retObj = {};
			if (state?.superAssetId === action.superAssetImages?.superAssetId)
			{
				for(let imageURL in Object.values(action.superAssetImages?.images || {}))
				{
					if(!isS3URLExpired(imageURL))
					{
						return { ...action.superAssetImages };
					}

				}
				const { mergedGroup: mergedSuperAssetImages, hasUpdated: hasSuperAssetImagesUpdated } = mergeAssetImageGroup(state.images, action.superAssetImages?.images);
				if(hasSuperAssetImagesUpdated)
				{
					retObj = { ...action.superAssetImages, images: mergedSuperAssetImages };
				}
			} else
			{
				retObj = { ...action.superAssetImages };
			}
			return retObj;
		case types.UPDATE_SUPER_ASSET_IMAGE:
			var superAssetStateClone = _.cloneDeep(state);
			for(let imageKey in action.updatedImageDetails)
			{
				if(superAssetStateClone["images"].hasOwnProperty(imageKey))
				{
					superAssetStateClone["images"][imageKey] = action.updatedImageDetails[imageKey];
				}
			}
			return superAssetStateClone;
		case types.DELETE_SUPER_ASSET_IMAGE:
			var superAssetStateClone = _.cloneDeep(state);
			var fileName = action.deletedSuperAssetImageDetails.fileName;
			if(superAssetStateClone?.images?.hasOwnProperty(fileName))
			{
				const { [fileName]: deleted, ...otherSuperAssetImages } = superAssetStateClone.images;
				superAssetStateClone.images = otherSuperAssetImages;
			}
			return superAssetStateClone;

		default:
			return state;
	}
}

export function assetImagesErrorReducer(state = InitialState.assetImagesErrorFlag, action) 
{
	switch (action.type)
	{
		case types.FETCH_ASSET_IMAGES_ERROR:
			return action.assetImagesErrorFlag;
		default:
			return state;
	}
}

export function assetImagesLoadingReducer(state = InitialState.assetImagesLoading, action) 
{
	switch (action.type)
	{
		case types.FETCH_ASSET_IMAGES_LOADING:
			return action.assetImagesLoading;
		default:
			return state;
	}
}

export function assetImagesReducer(state = InitialState.assetImages, action) 
{
	switch (action.type)
	{
		case types.FETCH_ASSET_IMAGES:
			var assetId = action.assetImages.assetId;
			const assetImages = action.assetImages  || {};
			const existingAssetImages = state[assetId];
			if(!existingAssetImages)
			{
				return {...state, [assetId]: action.assetImages};
			}

			const existingFlattened = {
				...(assetImages?.labelPictures || {}),
				...(assetImages?.componentPictures || {})
			};
			const sampleExistingImageURL = Object.values(existingFlattened).find(Boolean);
			if(!sampleExistingImageURL || isS3URLExpired(sampleExistingImageURL))
			{
				return {...state, [assetId]: action.assetImages};
			}

			const { mergedGroup: mergedLabelPictures, hasUpdated: labelPicturesUpdated } = mergeAssetImageGroup(existingAssetImages.labelPictures, assetImages.labelPictures);
			const { mergedGroup: mergedComponentPictures, hasUpdated: componentPicturesUpdated } = mergeAssetImageGroup(existingAssetImages.componentPictures, assetImages.componentPictures);

			if(labelPicturesUpdated || componentPicturesUpdated)
			{
				return {
					...state,
					[assetId]:{
						...existingAssetImages,
						...assetImages,
						labelPictures: mergedLabelPictures,
						componentPictures: mergedComponentPictures,
					}
				};
			}
			return state;
		case types.UPDATE_ASSET_IMAGE:
			var assetStateClone = _.cloneDeep(state);
			var assetId = action.updatedImageDetails.assetId;
			if(assetStateClone[assetId])
			{
				for (let imageType of ["labelPictures", "componentPictures"])
				{
					for (let imageKey in action.updatedImageDetails.image)
					{
						if (assetStateClone[assetId][imageType].hasOwnProperty(imageKey))
						{
							assetStateClone[assetId][imageType][imageKey] = action.updatedImageDetails.image[imageKey];
						}
					}
				}
			}
			return assetStateClone;

		case types.DELETE_ASSET_IMAGE:
			var assetStateClone = _.cloneDeep(state);
			var fileName = action.deletedAssetImageDetails.fileName;
			var assetId = action.deletedAssetImageDetails.assetId;
			if(assetStateClone[assetId])
			{
				for (let imageType of ["labelPictures", "componentPictures"])
				{
					if (assetStateClone[assetId][imageType]?.hasOwnProperty(fileName))
					{
						const { [fileName]: deleted, ...otherAssetImages } = assetStateClone[assetId][imageType];
						assetStateClone[assetId][imageType] = otherAssetImages;
					}
				}
			}
			return assetStateClone;

		default:
			return state;
	}
}

export function fetchUnattachedSensorListErrorReducer(state = InitialState.unattachedSensorListErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.FETCH_UNATTACHED_SENSOR_LIST_ERROR:
			return action.unattachedSensorListErrorFlag;
		default:
			return state;
	}
}

export function fetchUnattachedSensorListLoadingReducer(state = InitialState.unattachedSensorListLoading, action) 
{
	switch (action.type) 
	{
		case types.FETCH_UNATTACHED_SENSOR_LIST_LOADING:
			return action.unattachedSensorListLoading;
		default:
			return state;
	}
}

export function fetchUnattachedSensorListReducer(state = InitialState.unattachedSensorList, action)
{
	switch (action.type)
	{
		case types.FETCH_UNATTACHED_SENSOR_LIST:
			return action.unattachedSensorList
		default:
			return state
	}
}

export function updateSensorInfoLoadingReducer(state = InitialState.updateSensorInfoLoading, action) 
{
	switch (action.type) 
	{
		case types.UPDATE_SENSOR_INFO_LOADING:
			return action.updateSensorInfoLoading;
		default:
			return state;
	}
}

export function updateSensorInfoErrorReducer(state = InitialState.updateSensorInfoErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.UPDATE_SENSOR_INFO_ERROR:
			return action.updateSensorInfoErrorFlag;
		default:
			return state;
	}
}

export function detachSensorErrorReducer(state = InitialState.detachSensorErrorFlg, action) 
{
	switch (action.type) 
	{
		case types.DETACH_SENSOR_ERROR:
			return action.detachSensorErrorFlag;
		default:
			return state;
	}
}

export function detachSensorLoadingReducer(state = InitialState.detachSensorLoading, action) 
{
	switch (action.type) 
	{
		case types.DETACH_SENSOR_LOADING:
			return action.detachSensorLoading;
		default:
			return state;
	}
}

export function saveImageRotationErrorReducer(state = InitialState.saveImageRotationsAngleErrorFlag, action)
{
	switch (action.type)
	{
		case types.SAVE_IMAGE_ROTATION_ERROR:
			return action.saveImageRotationsAngleErrorFlag;
		default:
			return state;
	}
}

export function saveImageRotationLoadingReducer(state = InitialState.saveImageRotationsAngleLoading, action)
{
	switch (action.type)
	{
		case types.SAVE_IMAGE_ROTATION_LOADING:
			return action.saveImageRotationsAngleLoading;
		default:
			return state;
	}
}

export function deleteAssetImageErrorReducer(state = InitialState.deleteAssetImageErrorFlag, action)
{
	switch (action.type)
	{
		case types.DELETE_ASSET_IMAGE_ERROR:
			return action.deleteAssetImageErrorFlag;
		default:
			return state;
	}
}

export function deleteAssetImageLoadingReducer(state = InitialState.deleteAssetImageLoading, action)
{
	switch (action.type)
	{
		case types.DELETE_ASSET_IMAGE_LOADING:
			return action.deleteAssetImageLoading;
		default:
			return state;
	}
}

export function deleteSuperAssetImageErrorReducer(state = InitialState.deleteSuperAssetImageErrorFlag, action)
{
	switch (action.type)
	{
		case types.DELETE_SUPER_ASSET_IMAGE_ERROR:
			return action.deleteSuperAssetImageErrorFlag;
		default:
			return state;
	}
}

export function deleteSuperAssetImageLoadingReducer(state = InitialState.deleteSuperAssetImageLoading, action)
{
	switch (action.type)
	{
		case types.DELETE_SUPER_ASSET_IMAGE_LOADING:
			return action.deleteSuperAssetImageLoading;
		default:
			return state;
	}
}


export function fetchFeedbackTagsErrorReducer(state = InitialState.fetchFeedbackTagsErrorFlag, action)
{
	switch (action.type)
	{
		case types.FETCH_FEEDBACK_TAGS_ERROR:
			return action.fetchFeedbackTagsErrorFlag;
		default:
			return state;
	}
}

export function fetchFeedbackTagsLoadingReducer(state = InitialState.fetchFeedbackTagsLoading, action) 
{
	switch (action.type)
	{
		case types.FETCH_FEEDBACK_TAGS_LOADING:
			return action.fetchFeedbackTagsLoading;
		default:
			return state;
	}
}

export function fetchFeedbackTagsReducer(state = InitialState.fetchFeedbackTags, action) 
{
	switch (action.type) 
	{
		case types.FETCH_FEEDBACK_TAGS:
			return action.fetchFeedbackTags;
		default:
			return state;
	}
}

export function downloadFeedbackFilesErrorReducer(state = InitialState.downloadFeedbackFilesErrorFlag, action) 
{
	switch (action.type)
	{
		case types.DOWNLOAD_FEEDBACK_FILES_ERROR:
			return action.downloadFeedbackFilesErrorFlag;
		default:
			return state;
	}
}

export function downloadFeedbackFilesLoadingReducer(state = InitialState.downloadFeedbackFilesLoading, action) 
{
	switch (action.type)
	{
		case types.DOWNLOAD_FEEDBACK_FILES_LOADING:
			return action.downloadFeedbackFilesLoading;
		default:
			return state;
	}
}

export function feedbackAssetDetailsReducer(state = InitialState.feedbackAssetDetails, action) 
{
	switch (action.type) 
	{
		case types.FEEDBACK_ASSET_DETAILS_RESPONSE:
			return action.feedbackAssetDetails;
		default:
			return state;
	}
}

export function feedbackAssetDetailsErrorReducer(state = InitialState.feedbackAssetDetailsErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.FEEDBACK_ASSET_DETAILS_ERROR:
			return action.feedbackAssetDetailsErrorFlag;
		default:
			return state;
	}
}

export function feedbackAssetDetailsLoadingReducer(state = InitialState.feedbackAssetDetailsLoadingFlag, action) 
{
	switch (action.type) 
	{
		case types.FEEDBACK_ASSET_DETAILS_LOADING:
			
			return action.feedbackAssetDetailsLoadingFlag;
		default:
			return state;
	}
}


export function getProgramIdLoadingReducer(state = false, action)
{
	switch (action.type)
	{
		case types.GET_PROGRAM_ID_LOADING:
			return action.payload;
		case types.GET_PROGRAM_ID:
		case types.GET_PROGRAM_ID_ERROR:
			return false;
		default:
			return state;
	}
}

export function getProgramIdListReducer(state = [], action)
{
	switch (action.type)
	{
		case types.GET_PROGRAM_ID:
			return action.payload;
		case types.GET_PROGRAM_ID_ERROR:
			return [];
		default:
			return state;
	}
}
const mergeAssetImageGroup = (existingGroup = {}, incomingGroup = {}) =>
{
	let hasUpdated = false;
	const mergedGroup = { ...existingGroup };

	Object.keys(existingGroup || {}).forEach(imageKey =>
	{
		if(!Object.prototype.hasOwnProperty.call(incomingGroup || {}, imageKey))
		{
			delete mergedGroup[imageKey];
			hasUpdated = true;
		}
	});

	Object.keys(incomingGroup || {}).forEach(imageKey =>
	{
		const existingValue = mergedGroup[imageKey];
		const incomingValue = incomingGroup[imageKey];
		if(existingValue === undefined)
		{
			mergedGroup[imageKey] = incomingValue;
			hasUpdated = true;
			return;
		}

		if(isURL(existingValue) && isURL(incomingValue))
		{
			return;
		}

		if(existingValue !== incomingValue)
		{
			mergedGroup[imageKey] = incomingValue;
			hasUpdated = true;
		}
	});

	return { mergedGroup, hasUpdated };
};

export function updateAlternateIdErrorReducer(state = InitialState.updateAlternateIdErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.UPDATE_SUPER_ASSET_ALTERNATE_ID_ERROR:
			return action.updateAlternateIdErrorFlag;
		default:
			return state;
	}
}

export function updateAlternateIdLoadingReducer(state = InitialState.updateAlternateIdLoading, action) 
{
	switch (action.type) 
	{
		case types.UPDATE_SUPER_ASSET_ALTERNATE_ID_LOADING:
			return action.updateAlternateIdLoading;
		default:
			return state;
	}
}
